"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/collection/collection-store.ts
var _collectionstore = require('@ariakit/core/collection/collection-store'); var Core = _interopRequireWildcard(_collectionstore);
function useCollectionStoreProps(store, update, props) {
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, update, [props.store]);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "items", "setItems");
  return store;
}
function useCollectionStore(props = {}) {
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createCollectionStore, props);
  return useCollectionStoreProps(store, update, props);
}




exports.useCollectionStoreProps = useCollectionStoreProps; exports.useCollectionStore = useCollectionStore;
